import { render, staticRenderFns } from "./TabelaprecoManage.vue?vue&type=template&id=78c0703c&scoped=true"
import script from "./TabelaprecoManage.vue?vue&type=script&lang=js"
export * from "./TabelaprecoManage.vue?vue&type=script&lang=js"
import style0 from "./TabelaprecoManage.vue?vue&type=style&index=0&id=78c0703c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c0703c",
  null
  
)

export default component.exports